import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SalesRegHeader from "../../saleselements/SalesregHeader/SalesregHeader";
import DataTable from "../../saleselements/table/DataTable";
import SalesSideBar from "../../components/sales/SalesSideBar";
import commoncss from "../../css/common.module.css";
import DataState from "../../saleselements/common/DataState/DataState";
import ERPDataTable from "../../saleselements/table/ERPTable";

const Listing = () => {
  const [showDataState, setShowDataState] = useState(true);
  const [tableType, setTableType] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
  const { id: routeSaleId } = useParams();
  const [saleID, setSaleID] = useState("");
  const handleFiltersApplied = (filters) => {
    setAppliedFilters(filters);
  };

  const handleNoDataFound = () => {
    setAppliedFilters([]);
  };

  useEffect(() => {
    if (routeSaleId) {
      setSaleID(routeSaleId);
    }
  }, [routeSaleId]);

  useEffect(() => {
    if (showTable && tableType === null) {
      setTableType("excel");
    }
  }, [showTable, tableType]);

  return (
    <div style={{ display: "flex" }}>
      <SalesSideBar activeTab={"Listing"} saleID={saleID} />
      <div className={`${commoncss.widthScrHidden} px-3 py-2`}>
        <SalesRegHeader
          saleID={saleID}
          setSaleID={setSaleID}
          setShowDataState={setShowDataState}
          tableType={tableType}
          setTableType={setTableType}
          setShowTable={setShowTable}
          onFiltersApplied={handleFiltersApplied}
          showAddRegisterModal={showAddRegisterModal}
          setShowAddRegisterModal={setShowAddRegisterModal}
        />

        {showDataState && !showTable && (
          <DataState 
            setShowAddRegisterModal={setShowAddRegisterModal}
          />
        )}

        {showTable && tableType === "excel" && (
          <DataTable
            filters={appliedFilters}
            SaleID={saleID}
            onNoDataFound={handleNoDataFound}
          />
        )}
        {showTable && tableType === "erp" && <ERPDataTable />}
      </div>
    </div>
  );
};

export default Listing;